export interface ConditionValue {
    conditionType: string;
    value?: string;
    status?: string;
  }
  
  export const isEqualOrContains = (conditionType: string): boolean => {
    console.log(`Checking if conditionType "${conditionType}" is EQUAL_TO or CONTAINS`);
    return conditionType === "EQUAL_TO" || conditionType === "CONTAINS";
  };
  
  export const applySingleCondition = (
    conditionValue: ConditionValue,
    updatedValue: string,
    translatedSenderId: string
  ): string => {
    const { conditionType, value } = conditionValue;
    console.log(`Applying single condition:`, {
      conditionType,
      value,
      updatedValue,
      translatedSenderId,
    });
  
    if (conditionType === "IS_DIGIT") {
      if (/^\d+$/.test(updatedValue)) {
        const result = translatedSenderId;
        console.log(`IS_DIGIT applied. Entire value replaced. Result: ${result}`);
        return result;
      } else {
        console.log(`IS_DIGIT not applied. Input contains non-digits. Keeping original value.`);
        return updatedValue;
      }
    } else if (conditionType === "IS_NOT_DIGIT") {
      if (/^\D+$/.test(updatedValue)) {
        const result = translatedSenderId;
        console.log(`IS_NOT_DIGIT applied. Entire value replaced. Result: ${result}`);
        return result;
      } else {
        console.log(`IS_NOT_DIGIT not applied. Input contains digits. Keeping original value.`);
        return updatedValue;
      }
    } else if (conditionType === "EQUAL_TO") {
      if (updatedValue === value) {
        console.log(`EQUAL condition applied. Replacing value with translatedSenderId.`);
        return translatedSenderId;
      } else {
        console.log(
          `EQUAL condition not applied. Value "${value}" does not match updatedValue: "${updatedValue}".`
        );
        return updatedValue;
      }
    } else if (conditionType === "CONTAINS") {
      if (value && updatedValue.includes(value)) {
        console.log(`CONTAINS condition applied. Entire value replaced with translatedSenderId.`);
        return translatedSenderId; 
      } else {
        console.log(
          `CONTAINS condition not applied. Value "${value}" not found in input. Keeping original value: ${updatedValue}`
        );
        return updatedValue; 
      }
    }
  
    console.log(`No condition applied. Returning original value: ${updatedValue}`);
    return updatedValue;
  };
  
  
  
  export const applyAndConditions = (
    conditionValue1: ConditionValue,
    conditionValue2: ConditionValue,
    updatedValue: string,
    content: string,
    translatedValue: string
  ): string => {
    console.log(`Applying AND conditions:`, {
      conditionValue1,
      conditionValue2,
      updatedValue,
      content,
      translatedValue,
    });
  
    let result = updatedValue;
  
    if (conditionValue1.conditionType === "IS_DIGIT" && conditionValue2.conditionType === "IS_NOT_DIGIT") {
      console.log(`AND condition: IS_DIGIT and IS_NOT_DIGIT. No changes made.`);
    } else if (
      conditionValue1.conditionType === "IS_DIGIT" &&
      isEqualOrContains(conditionValue2.conditionType)
    ) {
      if (/\d/.test(content) && content.includes(conditionValue2.value || "")) {
        result = updatedValue
          .replace(/\d+/g, translatedValue)
          .replace(new RegExp(conditionValue2.value || "", "g"), translatedValue);
      }
    } else if (
      isEqualOrContains(conditionValue1.conditionType) &&
      conditionValue2.conditionType === "IS_DIGIT"
    ) {
      if (content.includes(conditionValue1.value || "") && /\d/.test(content)) {
        result = updatedValue
          .replace(new RegExp(conditionValue1.value || "", "g"), translatedValue)
          .replace(/\d+/g, translatedValue);
      }
    }
  
    console.log(`AND condition applied. Result: ${result}`);
    return result;
  };
  
  export const applyOrConditions = (
    conditionValue1: ConditionValue,
    conditionValue2: ConditionValue,
    updatedValue: string,
    content: string,
    translatedSenderId: string
  ): string => {
    console.log(`Applying OR conditions:`, {
      conditionValue1,
      conditionValue2,
      updatedValue,
      content,
      translatedSenderId,
    });
  
    if (conditionValue1.conditionType === "IS_DIGIT" && /^\d+$/.test(content)) {
      const result = translatedSenderId;
      console.log(`OR condition: IS_DIGIT applied for conditionValue1. Result: ${result}`);
      return result;
    }
  
    if (conditionValue1.conditionType === "IS_NOT_DIGIT" && /^\D+$/.test(content)) {
      const result = translatedSenderId;
      console.log(`OR condition: IS_NOT_DIGIT applied for conditionValue1. Result: ${result}`);
      return result;
    }
  
    if (
      isEqualOrContains(conditionValue1.conditionType) &&
      content.includes(conditionValue1.value || "")
    ) {
      const result = translatedSenderId;
      console.log(`OR condition: EQUAL_TO/CONTAINS applied for conditionValue1. Result: ${result}`);
      return result;
    }
  
    if (conditionValue2.conditionType === "IS_DIGIT" && /^\d+$/.test(content)) {
      const result = translatedSenderId;
      console.log(`OR condition: IS_DIGIT applied for conditionValue2. Result: ${result}`);
      return result;
    }
  
    if (conditionValue2.conditionType === "IS_NOT_DIGIT" && /^\D+$/.test(content)) {
      const result = translatedSenderId;
      console.log(`OR condition: IS_NOT_DIGIT applied for conditionValue2. Result: ${result}`);
      return result;
    }
  
    if (
      isEqualOrContains(conditionValue2.conditionType) &&
      content.includes(conditionValue2.value || "")
    ) {
      const result = translatedSenderId;
      console.log(`OR condition: EQUAL_TO/CONTAINS applied for conditionValue2. Result: ${result}`);
      return result;
    }
  
    console.log(`No OR condition applied. Returning original value: ${updatedValue}`);
    return updatedValue;
  };
  